import Head from "next/head";
import Customers from "../components/AiDataLake/AiCustomers/Customers";
import AiCardList from "../components/AiDataLake/AiInitiativeCardList/AiCardList";
import AiLanding from "../components/AiDataLake/AiLandinngPage/AiLanding";
import AiModel from "../components/AiDataLake/AiModel/AiModel";
import BestSolution from "../components/AiDataLake/BestSolution/BestSolution";
import ContactAi from "../components/AiDataLake/ContactAi/ContactAi";
import Evs from "../components/AiDataLake/EVS/Evs";
import ModelCardList from "../components/AiDataLake/ModelCardList/ModelCardList";
import styles from "../styles/AiDataLake.module.scss";
function dataLakeForAi() {
  return (
    <>
      <Head>
        <title>eTail Data Lake | Socommerz</title>
        <meta name="title" content="eTail Data Lake | Socommerz" />
        <meta
          name="description"
          content="Enhance your retail strategy with our eTail Data Lake. Store, integrate, and analyze large volumes of retail data to gain actionable insights and improve omnichannel customer experiences."
        />
        <meta
          name="keywords"
          content="Retail data lake,
Big data for retail,
Data storage for e-commerce,
Unified customer data,
ETL (Extract, Transform, Load) retail,
Data integration for eTail,
Real-time retail insights,
Omnichannel data management,
Retail data analytics,
e-commerce data lake architecture"
        />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.socommerz.com/eTail-data-lake/"
        />
        <meta property="og:title" content="eTail Data Lake | Socommerz" />
        <meta
          property="og:description"
          content="Enhance your retail strategy with our eTail Data Lake. Store, integrate, and analyze large volumes of retail data to gain actionable insights and improve omnichannel customer experiences."
        />
        <link
          rel="canonical"
          href="https://www.socommerz.com/eTail-data-lake/"
        />
        <link
          rel="alternate"
          href="https://www.socommerz.com/eTail-data-lake/"
          hrefLang="en-in"
        />
        <meta
          property="twitter:url"
          content="https://www.socommerz.com/eTail-data-lake/"
        />
        <meta property="twitter:title" content="eTail Data Lake | Socommerz" />
        <meta
          property="twitter:description"
          content="Enhance your retail strategy with our eTail Data Lake. Store, integrate, and analyze large volumes of retail data to gain actionable insights and improve omnichannel customer experiences."
        />
      </Head>
      <main>
        <div className={styles["ai-container"]}>
          <AiLanding />
          <Customers />
          <AiCardList />
          <AiModel />
          <BestSolution />
          {/* <ModelCardList /> */}
          <Evs />
          {/* <ContactAi /> */}
        </div>
      </main>
    </>
  );
}

export default dataLakeForAi;
